var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"no-signal-container"},[_c('img',{staticClass:"error-icon",attrs:{"src":_vm.noSignalIcon,"alt":"No Signal"}}),_c('h1',{staticClass:"error-title"},[_vm._v("No Signal")]),_c('p',{staticClass:"error-text"},[_vm._v("Invalid ByteArk Signal URL")])])
}
var staticRenderFns = []

export { render, staticRenderFns }